<template>
    <div>
        <div class="assess-student-msg-detail" >
            <div class="assess-student-msg-user" >
                <img :src="headPicUrl">
                <div class="assess-student-msg-info" >
                    <p>{{msgObj.userName}}（{{msgObj.className}}）</p>
                    <time>{{msgObj.makeTime}}</time>
                </div>
            </div>
            <p class="assess-student-msg-text" >{{msgObj.content}}</p>
            <div class="assess-student-msg-handler" >
                <span>受理部门：{{msgObj.roleName}}</span>
                <span>受理人员：{{msgObj.teacherName}}</span>
            </div>
        </div>
        <div class="assess-student-msg-apply" >
            <p class="assess-student-msg-apply-num" >回复{{replyList.length}}</p>
            <div class="assess-student-msg-apply-item" v-if="replyList.length" v-for="(msg,index) in replyList" :key="index" >
                <img :src="headPicUrl">
                <div class="assess-student-msg-apply-text" >
                    <h4>{{msg.userName}}（{{msg.jobName == 'undefined' ? '教师' : msg.jobName}}）</h4>
                    <span>{{msg.makeTime}}</span>
                    <p>
                        {{msg.content}}
                    </p>
                </div>
            </div>
        </div>
        <div class="comment-box-wrapper" v-show="isShowBox" >
            <div class="comment-box" >
                <span class="review" >回复：</span>
                <input type="text" class="input-box" @blur="focusState = false"  v-focus="focusState" v-model.trim="message" >
                <button class="btn-submint" @click="textSubmit" >提交</button>
            </div>
        </div>
        <div class="assess-student-msg-apply-btn" v-if="isShowBtn" >
            <button @click="msgApply" >回复</button>
        </div>
        <!-- 底部返回上一页 返回首页信息放这里 -->
        <bottom></bottom>
    </div>
</template>
<script>
import { getUserInfo } from '@/service/user-service.js'
import default_avatar from '@/assets/images/user.png?20241114'
import Bottom from '../bottom.vue'
import { Toast } from 'mint-ui';
export default {
    data() {
        return {
            headPicUrl: default_avatar,
            msgObj: {},                   //留言详情对象
            replyList: [],
            isShowBox: false,
            isShowBtn: true,
            id: Number(this.$route.query.id),
            userId: this.$route.query.userId,
            replyMsgObj: {},            //留言内容对象
            currentUserId: '',
            focusState: false,         //点击回复按钮，光标自动聚焦
            message: ''                //留言内容
        }
    },
    components: { Bottom },
    mounted() {
        this.$nextTick( () => {
            getUserInfo().then((user) => {
                this.currentUserId = user.userId;
                this.getMsgDetail();
            });
        });
    },
    methods: {
        getMsgDetail() {
            this.$http.get('/api/mobile/devel/comment/getLeave', {
                params: {
                    id: this.id,
                    thisUserId: this.currentUserId
                }
            }).then(res => {
                this.msgObj = res.data.data;
                this.replyList = res.data.appealList;
            })
        },
        msgApply() {
            this.isShowBox = true;
            this.focusState = true;
            this.isShowBtn = false;
        },
        textSubmit() {
            if(this.message == '') {
                Toast('回复不能为空！');
                return;
            }
            this.$http.get('/api/mobile/devel/comment/addLeave', {
                params: {
                    content: this.message,
                    leavId: this.id,                    //留言id
                    toUser: this.userId,                //回复用户id
                    userId: this.currentUserId          //当前用户id
                }
            }).then(res => {
                if(res.data.flag) {
                    this.isShowBox = false;
                    this.isShowBtn = true;
                    this.message = '';
                    this.getMsgDetail();
                }
            })
        }
    },
    directives: {
        focus: {
            update: function (el, value) {    //第二个参数传进来的是个json
                if (value) {
                    el.focus();
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/assessment/assess-student-msg-detail.vue